import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Alert from "@mui/material/Alert";
import shortid from "shortid";

import { showModal } from "../../../../../../store/slices/modal";
import { ManageLoadPostContext } from "../../..";
import { capitalizeFirstLetter } from "../../../../../../utils/helperFunc";

const LoadItem = () => {
  const dispatch = useDispatch();

  const [loadPostState, loadPostContextDispatch] = useContext(
    ManageLoadPostContext
  );
  const loadType = loadPostState.loadPostInfo?.load_type;
  const palletLoadList = loadPostState.loadPostInfo?.pallet_list;
  const stonesLoadList = loadPostState.loadPostInfo?.stones_list;
  const sandLoadList = loadPostState.loadPostInfo?.sand_list;
  const lateriteLoadList = loadPostState.loadPostInfo?.laterite_list;
  const barrelLoadList = loadPostState.loadPostInfo?.barrel_list;
  const vehicleLoadList = loadPostState.loadPostInfo?.vehicle_list;

  // Toggle loads collapse
  const toggleCollapse = (itemId, payloadType) => {
    loadPostContextDispatch({
      type: payloadType,
      payload: itemId,
    });
  };

  const openLoadManageModal = (item) => {
    if (loadType === "vehicle") {
      dispatch(
        showModal({
          modalName: "VehicleLoadManageModal",
          modalData: { isForUpdate: true, item, loadPostContextDispatch },
        })
      );
    } else if (loadType === "pallet") {
      dispatch(
        showModal({
          modalName: "PalletLoadManageModal",
          modalData: { isForUpdate: true, item, loadPostContextDispatch },
        })
      );
    } else if (loadType === "barrel") {
      dispatch(
        showModal({
          modalName: "BarrelLoadManageModal",
          modalData: { isForUpdate: true, item, loadPostContextDispatch },
        })
      );
    } else if (loadType === "stones") {
      dispatch(
        showModal({
          modalName: "StonesLoadManageModal",
          modalData: { isForUpdate: true, item, loadPostContextDispatch },
        })
      );
    } else if (loadType === "sand") {
      dispatch(
        showModal({
          modalName: "SandLoadManageModal",
          modalData: { isForUpdate: true, item, loadPostContextDispatch },
        })
      );
    }
  };
  const openLoadDeleteModal = (id, name, loadType) =>
    dispatch(
      showModal({
        modalName: "LoadDeleteModal",
        modalData: {
          id: id,
          title: name,
          typeOfLoad: loadType,
          loadPostContextDispatch,
        },
      })
    );

  // Manage load server errors
  const manageServerErrors = (errors, itemId) => {
    let error_messages = [];
    errors?.map((item) => {
      if (item.id == itemId) {
        Object.keys(item.error_messages).forEach(function (key) {
          error_messages.push(
            <Alert severity="error" key={shortid.generate()}>
              {key}: {item.error_messages[key]}
            </Alert>
          );
        });
      }
      return item;
    });
    return error_messages;
  };

  // Collapse open of stones loads if there is some errors
  useEffect(() => {
    loadPostState?.loadPostInfoErrors?.stones?.map((item) => {
      let findedItem = loadPostState?.loadPostInfo?.stones_list?.find(
        (item_) => item_.id == item.id
      );
      if (findedItem) {
        loadPostContextDispatch({
          type: "OPEN_STONES_LOAD_ITEM_COLLAPSE",
          payload: findedItem.id,
        });
      }
      return item;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPostState?.loadPostInfoErrors?.stones]);

  // Collapse open of sand loads if there is some errors
  useEffect(() => {
    loadPostState?.loadPostInfoErrors?.sand?.map((item) => {
      let findedItem = loadPostState?.loadPostInfo?.sand_list?.find(
        (item_) => item_.id == item.id
      );
      if (findedItem) {
        loadPostContextDispatch({
          type: "OPEN_SAND_LOAD_ITEM_COLLAPSE",
          payload: findedItem.id,
        });
      }
      return item;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPostState?.loadPostInfoErrors?.sand]);

  // Collapse open of laterite loads if there is some errors
  useEffect(() => {
    loadPostState?.loadPostInfoErrors?.laterite?.map((item) => {
      let findedItem = loadPostState?.loadPostInfo?.laterite_list?.find(
        (item_) => item_.id == item.id
      );
      if (findedItem) {
        loadPostContextDispatch({
          type: "OPEN_LATERITE_LOAD_ITEM_COLLAPSE",
          payload: findedItem.id,
        });
      }
      return item;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPostState?.loadPostInfoErrors?.laterite]);

  // Collapse open of pallet loads if there is some errors
  useEffect(() => {
    loadPostState?.loadPostInfoErrors?.pallet?.map((item) => {
      let findedItem = loadPostState?.loadPostInfo?.pallet_list?.find(
        (item_) => item_.id == item.id
      );
      if (findedItem) {
        loadPostContextDispatch({
          type: "OPEN_PALLET_LOAD_ITEM_COLLAPSE",
          payload: findedItem.id,
        });
      }
      return item;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPostState?.loadPostInfoErrors?.pallet]);

  // Collapse open of barrel loads if there is some errors
  useEffect(() => {
    loadPostState?.loadPostInfoErrors?.barrel?.map((item) => {
      let findedItem = loadPostState?.loadPostInfo?.barrel_list?.find(
        (item_) => item_.id == item.id
      );
      if (findedItem) {
        loadPostContextDispatch({
          type: "OPEN_BARREL_LOAD_ITEM_COLLAPSE",
          payload: findedItem.id,
        });
      }
      return item;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPostState?.loadPostInfoErrors?.barrel]);

  // Collapse open of vehicle loads if there is some errors
  useEffect(() => {
    loadPostState?.loadPostInfoErrors?.vehicle?.map((item) => {
      let findedItem = loadPostState?.loadPostInfo?.vehicle_list?.find(
        (item_) => item_.id == item.id
      );
      if (findedItem) {
        loadPostContextDispatch({
          type: "OPEN_VEHICLE_LOAD_ITEM_COLLAPSE",
          payload: findedItem.id,
        });
      }
      return item;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPostState?.loadPostInfoErrors?.vehicle]);

  return (
    <section className="load-post-loder-section">
      <div className="container">
        {loadType === "vehicle"
          ? vehicleLoadList?.map((item, index) => (
              <Accordion
                className="loader-container mb-1"
                key={item.id}
                expanded={item.isExpand}
                onChange={() =>
                  toggleCollapse(item.id, "TOGGLE_VEHICLE_LOAD_ITEM_COLLAPSE")
                }
              >
                <div className="loader-tittle">
                  <AccordionSummary
                    // expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    className="p-0"
                  >
                    <h1>
                      {capitalizeFirstLetter(loadType)} Load ({index + 1})
                      <i className="fa-solid fa-angle-right"></i>
                    </h1>
                  </AccordionSummary>
                  <div className="loader-remove-update-btn">
                    <button onClick={() => openLoadManageModal(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button
                      onClick={() =>
                        openLoadDeleteModal(item.id, item.model, "Vehicle")
                      }
                    >
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
                <AccordionDetails>
                  <VehicleTypeLoad
                    item={item}
                    loadPostState={loadPostState}
                    manageServerErrors={manageServerErrors}
                  />
                </AccordionDetails>
              </Accordion>
            ))
          : loadType === "pallet"
          ? palletLoadList?.map((item, index) => (
              <Accordion
                className="loader-container mb-1"
                key={item.id}
                expanded={item.isExpand}
                onChange={() =>
                  toggleCollapse(item.id, "TOGGLE_PALLET_LOAD_ITEM_COLLAPSE")
                }
              >
                <div className="loader-tittle">
                  <AccordionSummary
                    // expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    className="p-0"
                  >
                    <h1>
                      {capitalizeFirstLetter(loadType)} Load ({index + 1})
                      <i className="fa-solid fa-angle-right"></i>
                    </h1>
                  </AccordionSummary>
                  <div className="loader-remove-update-btn">
                    <button onClick={() => openLoadManageModal(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button
                      onClick={() =>
                        openLoadDeleteModal(item.id, item.name, "Pallet")
                      }
                    >
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
                <AccordionDetails>
                  <PalletTypeLoad
                    id={item.id}
                    name={item.name}
                    weight={item.weight}
                    height={item.height}
                    width={item.width}
                    length={item.length}
                    loadPostState={loadPostState}
                    manageServerErrors={manageServerErrors}
                  />
                </AccordionDetails>
              </Accordion>
            ))
          : loadType === "stones"
          ? stonesLoadList?.map((item, index) => (
              <Accordion
                className="loader-container mb-1"
                key={item.id}
                expanded={item.isExpand}
                onChange={() =>
                  toggleCollapse(
                    item.id,
                    "TOGGLE_STONES_LOAD_ITEM_COLLAPSE"
                  )
                }
              >
                <div className="loader-tittle">
                  <AccordionSummary
                    // expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    className="p-0"
                  >
                    <h1>
                      {capitalizeFirstLetter(loadType)} Load ({index + 1})
                      <i className="fa-solid fa-angle-right"></i>
                    </h1>
                  </AccordionSummary>
                  <div className="loader-remove-update-btn">
                    <button onClick={() => openLoadManageModal(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button
                      onClick={() =>
                        openLoadDeleteModal(item.id, item.total_trips, "Stones")
                      }
                    >
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
                <AccordionDetails>
                  <StonesTypeLoad
                    id={item.id}
                    total_trips={item.total_trips}
                    loadPostState={loadPostState}
                    manageServerErrors={manageServerErrors}
                  />
                </AccordionDetails>
              </Accordion>
            ))
          : loadType === "sand"
          ? sandLoadList?.map((item, index) => (
              <Accordion
                className="loader-container mb-1"
                key={item.id}
                expanded={item.isExpand}
                onChange={() =>
                  toggleCollapse(item.id, "TOGGLE_SAND_LOAD_ITEM_COLLAPSE")
                }
              >
                <div className="loader-tittle">
                  <AccordionSummary
                    // expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    className="p-0"
                  >
                    <h1>
                      {capitalizeFirstLetter(loadType)} Load ({index + 1})
                      <i className="fa-solid fa-angle-right"></i>
                    </h1>
                  </AccordionSummary>
                  <div className="loader-remove-update-btn">
                    <button onClick={() => openLoadManageModal(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button
                      onClick={() =>
                        openLoadDeleteModal(item.id, item.total_trips, "Sand")
                      }
                    >
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
                <AccordionDetails>
                  <SandTypeLoad
                    id={item.id}
                    total_trips={item.total_trips}
                    loadPostState={loadPostState}
                    manageServerErrors={manageServerErrors}
                  />
                </AccordionDetails>
              </Accordion>
            ))
          : loadType === "barrel"
          ? barrelLoadList?.map((item, index) => (
              <Accordion
                className="loader-container mb-1"
                key={item.id}
                expanded={item.isExpand}
                onChange={() =>
                  toggleCollapse(item.id, "TOGGLE_BARREL_LOAD_ITEM_COLLAPSE")
                }
              >
                <div className="loader-tittle">
                  <AccordionSummary
                    // expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    className="p-0"
                  >
                    <h1>
                      {capitalizeFirstLetter(loadType)} Load ({index + 1})
                      <i className="fa-solid fa-angle-right"></i>
                    </h1>
                  </AccordionSummary>
                  <div className="loader-remove-update-btn">
                    <button onClick={() => openLoadManageModal(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button
                      onClick={() =>
                        openLoadDeleteModal(item.id, item.name, "Barrel")
                      }
                    >
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
                <AccordionDetails>
                  <BarrelTypeLoad
                    id={item.id}
                    name={item.name}
                    weight={item.weight}
                    loadPostState={loadPostState}
                    manageServerErrors={manageServerErrors}
                  />
                </AccordionDetails>
              </Accordion>
            ))
          : loadType === "laterite"
          ? lateriteLoadList?.map((item, index) => (
              <Accordion
                className="loader-container mb-1"
                key={item.id}
                expanded={item.isExpand}
                onChange={() =>
                  toggleCollapse(item.id, "TOGGLE_LATERITE_LOAD_ITEM_COLLAPSE")
                }
              >
                <div className="loader-tittle">
                  <AccordionSummary
                    // expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    className="p-0"
                  >
                    <h1>
                      {capitalizeFirstLetter(loadType)} Load ({index + 1})
                      <i className="fa-solid fa-angle-right"></i>
                    </h1>
                  </AccordionSummary>
                  <div className="loader-remove-update-btn">
                    <button onClick={() => openLoadManageModal(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button
                      onClick={() =>
                        openLoadDeleteModal(item.id, item.total_trips, "Laterite")
                      }
                    >
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
                <AccordionDetails>
                  <LateriteTypeLoad
                    id={item.id}
                    total_trips={item.total_trips}
                    loadPostState={loadPostState}
                    manageServerErrors={manageServerErrors}
                  />
                </AccordionDetails>
              </Accordion>
            ))
          : null}
      </div>
    </section>
  );
};

const VehicleTypeLoad = ({ item, loadPostState, manageServerErrors }) => {
  return (
    <>
      {manageServerErrors(loadPostState?.loadPostInfoErrors?.vehicle, item.id)}
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Vehicles Model</label>
            <p>{item.model}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Vehicles State</label>
            <p>{item.state}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Vehicles License Plate</label>
            <p>{item.license_plate}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Vehicles Year</label>
            <p>{item.year}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Vehicle Type</label>
            <p>{item.vehicle_type}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Vehicles Lot Number</label>
            <p>{item.lot_number}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Vehicles Make</label>
            <p>{item.brand}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Vehicles Color</label>
            <p>{item.color}</p>
          </div>
          <div className="col-lg-4 profile-info-boxes">
            <label>Vehicles Additional Information</label>
            <p>{item.additional_information}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const PalletTypeLoad = ({
  id,
  name,
  weight,
  height,
  width,
  length,
  loadPostState,
  manageServerErrors,
}) => {
  return (
    <>
      {manageServerErrors(loadPostState?.loadPostInfoErrors?.pallet, id)}
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Name</label>
            <p>{name}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Weight</label>
            <p>{weight}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Height</label>
            <p>{height}</p>
          </div>
        </div>
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Width</label>
            <p>{width}</p>
          </div>
          <div className="col-lg-4 profile-info-boxes">
            <label>Length</label>
            <p>{length}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const StonesTypeLoad = ({
  id,
  total_trips,
  loadPostState,
  manageServerErrors,
}) => {
  return (
    <>
      {manageServerErrors(loadPostState?.loadPostInfoErrors?.stones, id)}
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Total Trips</label>
            <p>{total_trips}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const SandTypeLoad = ({
  id,
  total_trips,
  loadPostState,
  manageServerErrors,
}) => {
  return (
    <>
      {manageServerErrors(loadPostState?.loadPostInfoErrors?.sand, id)}
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Total Trips</label>
            <p>{total_trips}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const LateriteTypeLoad = ({ 
  id,
  total_trips,
  loadPostState,
  manageServerErrors,
}) => {
  return (
    <>
      {manageServerErrors(loadPostState?.loadPostInfoErrors?.laterite, id)}
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Total Trips</label>
            <p>{total_trips}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const BarrelTypeLoad = ({
  id,
  name,
  weight,
  loadPostState,
  manageServerErrors,
}) => {
  return (
    <>
      {manageServerErrors(loadPostState?.loadPostInfoErrors?.barrel, id)}
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Name</label>
            <p>{name}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Weight</label>
            <p>{weight}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(LoadItem);
